export const container = `
  flex flex-col flex-1
`;

export const innerContainer = `
  border flex items-center bg-ll-background
  rounded-sm focus-within:shadow-lg
  data-[has-error=true]:border-ll-error
  data-[has-error=false]:border-ll-border
`;

export const input = `
  border flex-1 text-ll-on-background h-[30px]
  inline-flex justify-center items-center py-0 px-2
  leading-none font-sans text-ll-font-size-h6 md:text-ll-font-size-p 
  `;

export const adornment = `
  h-full w-[20px] flex justify-center items-center mx-2
`;
